import React from 'react';
import PropTypes from 'prop-types';

import configureStore from './store/configure';
import { Provider } from 'react-redux';
import { prepareWorkflow } from './store/workflow/reducer';

import Header from './header';
import Workflow from './workflow';

const VoucherApprovalWorkflowEditor = ({ users, workflow }) => {
  const store = configureStore({
    static: {
      roles: workflow.roles,
      users: users
    },
    workflow: prepareWorkflow(workflow)
  });

  return (
    <Provider store={store}>
      <div className="d-flex flex-column gap-3">
        <Header />
        <Workflow />
      </div>
    </Provider>
  );
};

VoucherApprovalWorkflowEditor.propTypes = {
  users: PropTypes.array.isRequired,
  workflow: PropTypes.object.isRequired
};

export default VoucherApprovalWorkflowEditor;
